// @ts-nocheck
import { ModalUI } from 'sonata-react-components';
import styled from 'styled-components';

export const MyReportsModalStyle = styled(ModalUI)`
  .reportingActions {
    button {
      padding: 0;
      margin: 0;
    }
  }
  /* Overrides Foundation global button:hover/:focus leaking into the tabs (the modal is portaled outside .reporting). */
  .tab__button:hover,
  .tab__button:focus {
    background-color: unset;
  }
  .tabContainer {
    padding: 16px;
  }
  .tabFilters {
    align-items: center;
    display: flex;
    gap: 8px;
  }
  .tabActions {
    padding-top: 20px;
    display: flex;
    justify-content: flex-end;

    & > .buttonWrapper {
      padding: 0;
    }
  }
`;
